import { ConfirmationDialogData, ModalServiceBase as ModalServiceBase } from '@ebeihilfe/core';
import { Injectable, Type, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, firstValueFrom, lastValueFrom } from 'rxjs';

import { ConfirmDialogComponent } from '../../components/confirm-modal/confirm-dialog.component';
import { ImageModalComponent } from '../../components/image-modal';
@Injectable({
  providedIn: 'root',
})
export class ModalService extends ModalServiceBase {
  private readonly dialog = inject(MatDialog);

  public openModal<TComponent, TResult, TData>(
    component: Type<TComponent>,
    modalData?: TData,
  ): Promise<TResult | undefined> {
    const dialogRef = this.dialog.open<TComponent, TData, TResult>(component, {
      disableClose: true,
      maxWidth: '1000px',
      data: modalData,
      autoFocus: true,
    });

    return firstValueFrom(dialogRef.afterClosed());
  }

  public openDialog<TComponent, TResult, TData>(
    component: Type<TComponent>,
    dialogData?: TData,
    config?: MatDialogConfig<TData>,
  ): Observable<TResult | undefined> {
    const dialogRef = this.dialog.open<TComponent, TData, TResult>(component, {
      disableClose: true,
      ...config,
      data: dialogData,
      autoFocus: true,
    });
    return dialogRef.afterClosed();
  }

  public openConfirmationModal(modalData?: ConfirmationDialogData): Promise<boolean | undefined> {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmationDialogData, boolean>(
      ConfirmDialogComponent,
      {
        disableClose: true,
        maxWidth: '90vw' /* height: '20vh'*/,
        data: modalData,
        autoFocus: true,
      },
    );

    return lastValueFrom(dialogRef.afterClosed());
  }

  public async openImageModal(imageBlob: Blob, editMode = false): Promise<Blob | null> {
    const dialogRef = this.dialog.open(ImageModalComponent, {
      data: { imageBlob, editMode },
      maxWidth: '90vw',
      maxHeight: '90vh',
      panelClass: 'test',
    });

    const imagePreviewResult: { hasChanged: boolean; imageBlob: Blob } = await firstValueFrom(dialogRef.afterClosed());

    return imagePreviewResult?.hasChanged ? imagePreviewResult.imageBlob : null;
  }
}
